module.exports = __webpack_public_path__ + "static/media/fajar.817caa78.png";